import React from 'react'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'

import useAmenitiesApi from '../hooks/amenities/useAmenitiesApi'
import AmenityForm from '../components/amenities/AmenityForm'

export default function CreateAmenityPage() {
  const location = useLocation()
  const history = useHistory()

  const [_, methods] = useAmenitiesApi()

  return (
    <AmenityForm
      onSubmit={async (values) => {
        try {
          if (values.id) {
            await methods.updateAmenity(values)
          } else {
            await methods.createAmenity(values)
          }
          history.push('/amenities')
        } catch (error) {
          // Error handling is done in the hook
        }
      }}
      handleCancel={() => history.push('/amenities')}
      amenity={location.state && location.state.amenity}
    />
  )
}
